import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LineItemModel } from './LineItem.model';
import { AdditionalFeeModel } from './AdditionalFee.model';
import { PriceModel } from './Price.model';
import { ShippingOptionModel } from './ShippingOption.model';
import { AppliedDiscountModel } from './AppliedDiscount.model';
export class CheckoutModel {
  constructor(checkoutModel) {
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "cartId", void 0);
    _defineProperty(this, "purchaseFlowId", void 0);
    _defineProperty(this, "payNow", void 0);
    _defineProperty(this, "additionalFees", void 0);
    _defineProperty(this, "giftCard", void 0);
    _defineProperty(this, "payNowTotalAfterGiftCard", void 0);
    _defineProperty(this, "appliedDiscounts", void 0);
    _defineProperty(this, "lineItems", void 0);
    _defineProperty(this, "shippingInfo", void 0);
    _defineProperty(this, "currency", void 0);
    _defineProperty(this, "violations", void 0);
    _defineProperty(this, "calculationErrors", void 0);
    this.id = checkoutModel.id;
    this.cartId = checkoutModel.cartId;
    this.purchaseFlowId = checkoutModel.purchaseFlowId;
    this.payNow = checkoutModel.payNow;
    this.additionalFees = checkoutModel.additionalFees;
    this.giftCard = checkoutModel.giftCard;
    this.payNowTotalAfterGiftCard = checkoutModel.payNowTotalAfterGiftCard;
    this.appliedDiscounts = checkoutModel.appliedDiscounts;
    this.lineItems = checkoutModel.lineItems;
    this.shippingInfo = checkoutModel.shippingInfo;
    this.currency = checkoutModel.currency;
    this.violations = checkoutModel.violations;
    this.calculationErrors = checkoutModel.calculationErrors;
  }
  static fromV1(sdkCheckout) {
    var _sdkCheckout$payNow, _sdkCheckout$payNow2, _sdkCheckout$payNow3, _sdkCheckout$addition, _sdkCheckout$giftCard, _sdkCheckout$appliedD, _sdkCheckout$lineItem, _sdkCheckout$shipping;
    const modelContext = {
      useConvertedPrices: sdkCheckout.conversionCurrency !== sdkCheckout.currency && sdkCheckout.paymentCurrency === sdkCheckout.conversionCurrency
    };
    return new CheckoutModel({
      id: sdkCheckout._id,
      cartId: sdkCheckout.cartId,
      purchaseFlowId: sdkCheckout.purchaseFlowId,
      payNow: {
        shipping: PriceModel.fromV1((_sdkCheckout$payNow = sdkCheckout.payNow) == null ? void 0 : _sdkCheckout$payNow.shipping, modelContext),
        tax: PriceModel.fromV1((_sdkCheckout$payNow2 = sdkCheckout.payNow) == null ? void 0 : _sdkCheckout$payNow2.tax, modelContext),
        discount: PriceModel.fromV1((_sdkCheckout$payNow3 = sdkCheckout.payNow) == null ? void 0 : _sdkCheckout$payNow3.discount, modelContext)
      },
      additionalFees: (_sdkCheckout$addition = sdkCheckout.additionalFees) == null ? void 0 : _sdkCheckout$addition.map(additionalFee => AdditionalFeeModel.fromV1(additionalFee, modelContext)),
      giftCard: sdkCheckout.giftCard ? {
        amount: PriceModel.fromV1((_sdkCheckout$giftCard = sdkCheckout.giftCard) == null ? void 0 : _sdkCheckout$giftCard.amount, modelContext)
      } : undefined,
      payNowTotalAfterGiftCard: PriceModel.fromV1(sdkCheckout.payNowTotalAfterGiftCard, modelContext),
      appliedDiscounts: (_sdkCheckout$appliedD = sdkCheckout.appliedDiscounts) == null ? void 0 : _sdkCheckout$appliedD.map(appliedDiscount => AppliedDiscountModel.fromV1(appliedDiscount, modelContext)),
      lineItems: (_sdkCheckout$lineItem = sdkCheckout.lineItems) == null ? void 0 : _sdkCheckout$lineItem.map(lineItem => LineItemModel.fromV1(lineItem, modelContext)),
      shippingInfo: {
        selectedCarrierServiceOption: sdkCheckout.shippingInfo.selectedCarrierServiceOption ? {
          code: sdkCheckout.shippingInfo.selectedCarrierServiceOption.code,
          cost: {
            price: sdkCheckout.shippingInfo.selectedCarrierServiceOption.cost ? PriceModel.fromV1(sdkCheckout.shippingInfo.selectedCarrierServiceOption.cost.price, modelContext) : undefined
          }
        } : undefined,
        carrierServiceOptions: (_sdkCheckout$shipping = sdkCheckout.shippingInfo.carrierServiceOptions) == null ? void 0 : _sdkCheckout$shipping.map(carrierServiceOption => ({
          shippingOptions: (carrierServiceOption.shippingOptions || []).map(shippingOption => ShippingOptionModel.fromV1(shippingOption, modelContext))
        }))
      },
      currency: sdkCheckout.currency,
      violations: sdkCheckout.violations,
      calculationErrors: sdkCheckout.calculationErrors
    });
  }
}
//# sourceMappingURL=Checkout.model.js.map